/**
 * RF S5: the command center mounts (and so polls, every 15 s) a mission snapshot only for rows
 * with an assignment. An unassigned (location, role) row has no mission to show.
 */
export function shouldLoadMissionSnapshot(row: { assignment: unknown }): boolean {
  return row.assignment !== null && row.assignment !== undefined;
}
